import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseDeleteMaintenanceWorkflowScheduleProps {
  onSuccess: () => void
  onError: (error: any) => void
}

export const useDeleteMaintenanceWorkflowSchedule = ({ onSuccess, onError }: UseDeleteMaintenanceWorkflowScheduleProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['deleteMaintenanceWorkflowSchedule'],
    mutationFn: async (workflowScheduleId?: string) => {
      return privateAxios.delete(`/maintenance/workflow_schedules/${workflowScheduleId}`)
    },
    onSuccess,
    onError,
  })
}
